export default __webpack_public_path__ + "static/screen_2_01.js-83e65bd18db00e8f2c71f2a14d9ff7af.svg";